import React from 'react'
import { FileSearchOutlined } from '@ant-design/icons'
import StatusMessage from '../../components/statusMessage/StatusMessage'

/**
 * Landar här gör allt som inte matchar en deklarerad rutt. Vanligaste vägen hit är ett
 * gammalt bokmärke — `/app/nytt-arende` togs bort i #30, och den adressen lever kvar hos
 * den som sparade den.
 *
 * Ingen brödtext: rubriken säger allt som går att säga, och en uppmaning att kontakta
 * någon leder ingenstans när sidan helt enkelt inte finns. Knappen är vägen vidare.
 *
 * Rutten är en vanlig `Route`, inte `GuardedRoute`: 404 får inte kräva behörighet.
 */
const notFoundPage = () => {
  return <StatusMessage icon={<FileSearchOutlined />} title="Sidan finns inte" />
}

export default notFoundPage
